<template>

    <m-edit1/>

    <m-posts-1 v-bind='{...{"cardLink":false,"slicer":12,"contentType":"post","paginate":true,"categoryPanel":true,"flatCategoriesShape":true,"contentCategories":null,"postCard":"mPostCard911"},...{}}' :style='""' class="my-5 container" ></m-posts-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mPosts1 from '@moeinmdn/miw-alpha-components/src/package/Post/Posts/Posts1';

export default {
    name: 'HomeView',
    components: {mEdit1, mPosts1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
